module.exports = __webpack_public_path__ + "img/island-candos-logo.38c063aa.png";